import { Component, OnInit } from '@angular/core';
import { cloneDeep } from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConfigurationModel } from 'src/app/models/configuration';
import { ColorOfType, ColorSettings } from 'src/app/models/UserSettings';
import { ConfigurationColorService } from 'src/app/services/configuration-color-service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { PointsService } from 'src/app/services/points.service';
import { UserSettingsService } from 'src/app/services/userSettings.service';

@Component({
  selector: 'app-configuration-color-settings',
  templateUrl: './configuration-color-settings.component.html',
  styleUrls: ['../../app.component.scss', './configuration-color-settings.component.scss'],
  standalone: false
})

export class ConfigurationColorSettingsComponent implements OnInit {

  public navaidActive = false;
  public coordPointsActive = false;
  public airSpaceBoundaries = false;
  public tabOpened = 'Navaids';

  constructor(public pointsService: PointsService,
    public bsModalRef: BsModalRef,
      public configurationColorService: ConfigurationColorService,
      public confirmationModalService : ModalConfirmationService,
      public userSettingsService: UserSettingsService
    ) { }

  ngOnInit(): void {
    this.configurationColorService.initialize();

    document.getElementById("defaultOpen").click();

  }
  getObjectKeys(object){
      return Object.keys(object);
  }

  openTab(evt: Event, tabName: string) {
    this.tabOpened = tabName;
    const tabcontent = document.getElementsByClassName("tabcontent") as HTMLCollectionOf<HTMLElement>;
    for (let i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    const tablinks = document.getElementsByClassName("tablinks") as HTMLCollectionOf<HTMLElement>;
    for (let i = 0; i < tablinks.length; i++) {
      tablinks[i].classList.remove("active");
    }

    const selectedCity = document.getElementById(tabName);
    if (selectedCity) {
      selectedCity.style.display = "flex";
    }

    (evt.currentTarget as HTMLElement).classList.add("active");
  }
  applyChange(type:string){
    this.confirmationModalService.showMesssageConfirmationModal("Apply Color Change", "Do you wish to apply the changes?","Yes","Cancel",
    () =>{this.applyChangeColor(type); this.bsModalRef.hide()})
  }
  restore(type :string){
    this.confirmationModalService.showMesssageConfirmationModal("Restore Color", "Do you wish to restore the colors to default?","Yes","Cancel",
    () =>{this.restoreChanges(type); this.bsModalRef.hide()})
  }
  restoreChanges(type:string){
    this.configurationColorService.colorOfTypesChange = cloneDeep(new ColorSettings());
    this.applyChangeColor(type);
  }

  applyChangeColor(type:string){

    let colorObject : any = this.userSettingsService.getColorObject(type);
    let colorObjectChanged : any = this.userSettingsService.getColorObjectFromColorSettings(this.configurationColorService.colorOfTypesChange,type);
    if(type == 'Air Space Boundary'){
      if(colorObject != colorObjectChanged){
        this.pointsService.changeColorOfType(type,'all', null,colorObjectChanged);
        this.userSettingsService.userSettings.colorSettings = cloneDeep(this.configurationColorService.colorOfTypesChange);
        this.userSettingsService.updateSettings();
      }
      return;
    }

    let all_changed = false;
    if (colorObject.all != null && colorObjectChanged.all[0].color != ''){
      if(colorObject.all[0].color != colorObjectChanged.all[0].color){
        all_changed = true

        let changedKeys = Object.keys(colorObjectChanged);
          changedKeys.filter((key)=> key != 'all').forEach((key)=>{
            colorObjectChanged[key] = [{color:''},{color:''}];;
          })
        }
        this.pointsService.changeColorOfType(type,'all',false,colorObjectChanged.all[0].color);
      }
    if(!all_changed){
      for(let subtype of Object.keys(colorObject)){
        for(let i = 0; i < colorObject[subtype].length; i++){
          if(colorObjectChanged[subtype][i].color != colorObject[subtype][i].color){
            this.pointsService.changeColorOfType(type, subtype,i == 1,colorObjectChanged[subtype][i].color);
          }
        }
      }
    }

    this.userSettingsService.userSettings.colorSettings = cloneDeep(this.configurationColorService.colorOfTypesChange);
    this.userSettingsService.updateSettings();
  }
}

